import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const schoolsApi = createApi({
  reducerPath: "schoolsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    validateStatus: (response) => {
      if (response.status === 401) {
        window.location.href = "/login";
        return false;
      } else if (response.status >= 200 && response.status < 300) {
        return true;
      } else {
        throw new Error(`HTTP error ${response.status}`);
      }
    },
  }),
  endpoints: (builder) => ({
    
    getAllSchools: builder.mutation({
      query: () => ({
        url: "/v1/userservice/api/user/getActiveSchools",
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),

    getAllMaster: builder.mutation({
      query: (body) => ({
        url: "/v1/userservice/api/user/getMaster",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    
    getSchoolById: builder.mutation({
      query: (body) => ({
        url: "/v1/userservice/api/user/getActiveSchools",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    
    createSchool: builder.mutation({
      query: (body) => ({
        url: "/v1/userservice/api/user/createSchool",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    updateSchool: builder.mutation({
      query: (body) => ({
        url: `/v1/userservice/api/user/updateSchool`,
        method: "PUT",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    deleteSchool: builder.mutation({
      query: (body) => ({
        url: `/v1/userservice/api/user/deactivateSchool`,
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
  }),
});

export const {
  useGetAllSchoolsMutation,
  useGetAllMasterMutation,
  useGetSchoolByIdMutation,
  useCreateSchoolMutation,
  useUpdateSchoolMutation,
  useDeleteSchoolMutation,
} = schoolsApi;
